/**
 * Carga de fuentes de empresa en el NAVEGADOR vía FontFace API: el editor pinta con la
 * misma letra que el renderer (que las incrusta por @font-face desde el asset propio).
 */
export interface FuenteCargable {
  fuenteId: string;
  familia: string;
  url: string | null;
  peso: number;
  italic: boolean;
}

const cargadas = new Set<string>();

export async function registrarFuentes(fuentes: FuenteCargable[]): Promise<void> {
  await Promise.all(
    fuentes
      .filter((f) => f.url)
      .map(async (f) => {
        const clave = `${f.familia}|${f.peso}|${f.italic}`;
        if (cargadas.has(clave)) return;
        cargadas.add(clave);
        try {
          const cara = new FontFace(f.familia, `url(${f.url})`, {
            weight: String(f.peso),
            style: f.italic ? 'italic' : 'normal',
          });
          await cara.load();
          document.fonts.add(cara);
        } catch {
          cargadas.delete(clave); // URL firmada vencida: se reintenta en la próxima carga
        }
      }),
  );
}


/**
 * Preview de una familia de Google en el NAVEGADOR (sólo para elegir): inyecta el CSS
 * de Google una vez por familia. El renderer jamás usa esto — al elegir se autoaloja.
 */
const previews = new Set<string>();
export function previewGoogle(familia: string, pesos: number[] = [400]): void {
  if (previews.has(familia)) return;
  previews.add(familia);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(familia).replace(/%20/g, '+')}:wght@${[...new Set(pesos)].sort((a, b) => a - b).join(';')}&display=swap`;
  document.head.appendChild(link);
}
